export default __webpack_public_path__ + "static/media/VForVendetta.2902c80f.jpeg";